export const SUCCESSFULLY_AUTHENTICATED = 'SUCCESSFULLY_AUTHENTICATED';
export const SIGNED_OUT_SUCCESSFULLY = 'SIGNED_OUT_SUCCESSFULLY';

export const FAILED_AUTHENTICATION = 'FAILED_AUTHENTICATION';

export const SUCCESSFULLY_AUTHENTICATED_USING_COOKIES =
  'SUCCESSFULLY_AUTHENTICATED_USING_COOKIES';
